import { Footer } from 'src/viewLayer/components/DesignSystem';

import { LOCALE } from 'src/dataLayer/env';
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream';
import type { FooterContent } from './types';

/*
eslint-disable-next-line import/no-dynamic-require, @typescript-eslint/no-var-requires,
unicorn/prefer-module, @typescript-eslint/no-unsafe-assignment -- we need to require the json file here
*/
const footerContent: FooterContent = require(`src/config/translatedFooterContent/${LOCALE}.json`);

const handleFooterLinkClick = (footerLinkId: string): void => {
  trackGuiInteracted({ guiElementName: footerLinkId });
};

export default (): JSX.Element => (
  <Footer color="transparent">
    {Object.entries(footerContent).map(([sectionName, sectionLinks]) => (
      <Footer.Section sectionName={sectionName} key={sectionName}>
        { sectionLinks.map((sectionLinkData) =>
          <Footer.Item key={sectionLinkData.id}>
            <Footer.Link
              { ...sectionLinkData }
              onClick={ handleFooterLinkClick }
              sectionName={ sectionName }
            >
              { sectionLinkData.title }
            </Footer.Link>
          </Footer.Item>
        )}
      </Footer.Section>
    ))}
  </Footer>
);
